var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgStars = function SvgStars(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1048,
    height: 1076,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m524 256 3.263 304.137L653.41 266.904 533.567 561.218 774 298.872 539.219 563.306l338.334-213.58L543.834 566.26 957.013 416 547.097 569.877l459.863-76.699-458.174 80.734L1024 576l-475.214 2.088 458.174 80.734-459.863-76.699L957.013 736 543.834 585.74l333.719 216.534-338.334-213.58L774 853.128 533.567 590.782 653.41 885.096 527.263 591.863 524 896l-3.263-304.137L394.59 885.096l119.843-294.314L274 853.128l234.781-264.434-338.334 213.58L504.166 585.74 90.987 736l409.916-153.877-459.866 76.699 458.177-80.734L24 576l475.214-2.088-458.177-80.734 459.866 76.699L90.987 416l413.179 150.26-333.719-216.534 338.334 213.58L274 298.872l240.433 262.346L394.59 266.904l126.147 293.233L524 256Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__c)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m652.842 453.212 28.455-33.054"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__e)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m647.283 515.501 71.831-54.784"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__g)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m401.519 510.06-73.183-52.965"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__h)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__i)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m484.752 489.931-25.916-35.08"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__j)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__k)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m384.199 434.55-30.24-31.429"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__l)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__m)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m568.275 487.245 18.45-39.52"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#stars_svg__n)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "url(#stars_svg__o)",
    strokeWidth: 3,
    strokeLinecap: "round",
    d: "m526.675 519.201 1.088-33.001"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__a",
    x: 0,
    y: 232,
    width: 1048,
    height: 688,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__b",
    x: 649.342,
    y: 416.658,
    width: 35.455,
    height: 40.054,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__d",
    x: 643.783,
    y: 457.217,
    width: 78.831,
    height: 61.784,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__f",
    x: 324.836,
    y: 453.595,
    width: 80.183,
    height: 59.966,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__h",
    x: 455.336,
    y: 451.352,
    width: 32.916,
    height: 42.08,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__j",
    x: 350.459,
    y: 399.621,
    width: 37.24,
    height: 38.429,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__l",
    x: 564.775,
    y: 444.224,
    width: 25.45,
    height: 46.522,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "stars_svg__n",
    x: 523.175,
    y: 482.7,
    width: 8.088,
    height: 40.002,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_440:32428"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__c",
    x1: 682.035,
    y1: 418.348,
    x2: 651.623,
    y2: 453.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__e",
    x1: 720.492,
    y1: 458.884,
    x2: 646.276,
    y2: 515.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__g",
    x1: 326.184,
    y1: 456.304,
    x2: 401.797,
    y2: 511.028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__i",
    x1: 457.235,
    y1: 453.73,
    x2: 484.934,
    y2: 491.223,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__k",
    x1: 352.227,
    y1: 402.216,
    x2: 384.547,
    y2: 435.807,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.071,
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__m",
    x1: 586.946,
    y1: 445.783,
    x2: 567.227,
    y2: 488.021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "stars_svg__o",
    x1: 527.2,
    y1: 484.407,
    x2: 526.014,
    y2: 520.407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.495,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))));
};

export default SvgStars;